// extracted by mini-css-extract-plugin
export default {"moderationErrorItem":"FA2xnVFuGtFOel6pUABn","message":"T0j8GRA_8C6DRRTFGbqH","appealLink":"a2lxWdXAxgRplJA_m0CJ"};